import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export function TableShell({ children, search, onSearch, searchPlaceholder = "Search...", right }) {
  return (
    <div className="rounded-xl border border-border bg-card">
      {(onSearch || right) && (
        <div className="flex flex-wrap items-center gap-3 border-b border-border p-3">
          {onSearch && (
            <div className="relative w-full max-w-xs">
              <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
              <Input value={search} onChange={(e) => onSearch(e.target.value)} placeholder={searchPlaceholder} className="pl-9" data-testid="table-search" />
            </div>
          )}
          <div className="ml-auto flex items-center gap-2">{right}</div>
        </div>
      )}
      <div className="overflow-x-auto">
        <table className="w-full text-sm">{children}</table>
      </div>
    </div>
  );
}

export function Th({ children, className = "", ...rest }) {
  return <th {...rest} className={`whitespace-nowrap px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground ${className}`}>{children}</th>;
}

export function Td({ children, className = "", ...rest }) {
  return <td {...rest} className={`whitespace-nowrap px-4 py-3 ${className}`}>{children}</td>;
}

export function EmptyRow({ colSpan, text = "No records found." }) {
  return <tr><td colSpan={colSpan} className="px-4 py-12 text-center text-muted-foreground">{text}</td></tr>;
}
